import { BlitsError } from "./blits.error";

export class ExpiredJwtError extends BlitsError {

    static CODE = "expired_jwt_code";

    constructor(message?: string) {
        super(ExpiredJwtError.CODE, message || "JWT has expired");
    }
}